module.exports = __webpack_public_path__ + "static/media/family.f8c45c40.jpg";